<ion-content class="ion-no-padding">
  <form [formGroup]="paymentForm" class="lead-form model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">{{ forRefund ? "Refund Details" : "Add Payment"}}</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          
          <ion-button class="filled-blue-btn" (click)="onSubmit()">Save</ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content">
      <div class="dashed-line mb-1"></div>

      <div class="ion-padding-horizontal d-flex justify-content-between">
        <ion-title class="dark-title-sm ion-no-padding">{{forRefund? "Refund" : "Payment"}} Details</ion-title>
      </div>
      <div class="form-container ion-padding-horizontal toggle-visibility">
        <div class="row" *ngIf="!isPaymentRaisedAgainstLead">
          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">{{invoiceType === INVOICE_TYPES.CUSTOMER ? "Client Name": "Vendor Name"}}*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('clientName')?.invalid && paymentForm.get('clientName')?.touched }">
                <input formControlName="clientName" type="text" class="input" [appMaxLength]="50">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Invoice ID*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('invoiceNumber')?.invalid && paymentForm.get('invoiceNumber')?.touched }">
                <input formControlName="invoiceNumber" type="text" class="input">
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Total Amount*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('totalAmount')?.invalid && paymentForm.get('totalAmount')?.touched }">
                <app-select-text-input formControlName="totalAmount" [prefix]="selectedCurrency"></app-select-text-input>
              </div>
            </div>
          </div>

          <div class="col-3">
            <div class="input-container">
              <label for="" class="label">Balance Amount*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('currentBalanceAmount')?.invalid && paymentForm.get('currentBalanceAmount')?.touched }">
                <app-select-text-input formControlName="currentBalanceAmount" [prefix]="selectedCurrency"></app-select-text-input>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="input-container">
              <label for="" class="label">Payment Method*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('paymentMethod')?.invalid && paymentForm.get('paymentMethod')?.touched }">
                <input formControlName="paymentMethod" type="text" class="input" placeholder="Ex- Cash/NEFT/UPI" [appMaxLength]="20">
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="" class="label">{{forRefund ? "Refund" : (invoiceType === INVOICE_TYPES.CUSTOMER ? "Received": "Paid")}} Amount* 
                <span class="warning-message" *ngIf="paymentForm.get('requestedAmount')?.hasError('amountOutOfRange')">Invalid amount</span>
              </label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('requestedAmount')?.invalid && paymentForm.get('requestedAmount')?.touched }">
                <app-select-text-input formControlName="requestedAmount" [prefix]="selectedCurrency"></app-select-text-input>
              </div>
            </div>
          </div>

          
          <div class="col-4">
            <div class="input-container">
              <label for="" class="label">{{isPaymentRaisedAgainstLead ? "Total Amount Received For Lead" : "Updated Balance"}}*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('updatedBalanceAmount')?.invalid && paymentForm.get('updatedBalanceAmount')?.touched }">
                <app-select-text-input formControlName="updatedBalanceAmount" [prefix]="selectedCurrency" [readonly]="true"></app-select-text-input>
              </div>
            </div>
          </div>
        
        </div>

        <div class="row">
          <div class="col-4">
            <div class="input-container">
              <label for="" class="label">Payment Reference Number</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('paymentReferenceNumber')?.invalid && paymentForm.get('paymentReferenceNumber')?.touched }">
                <input type="text" formControlName="paymentReferenceNumber" class="input" placeholder="Enter Reference Number" [appMaxLength]="30">
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="input-container">
              <label for="" class="label">{{forRefund ? "Refund" : (invoiceType === INVOICE_TYPES.CUSTOMER ? "Received": "Paid")}} Date*</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('paymentDate')?.invalid && paymentForm.get('paymentDate')?.touched }">
                <app-date-picker formControlName="paymentDate" [maxDate]="todayDate"></app-date-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="input-container">
              <label for="" class="label">Notes</label>
              <div [ngClass]="{ 'invalid-input': paymentForm.get('paymentNotes')?.invalid && paymentForm.get('paymentNotes')?.touched }">
                <textarea formControlName="paymentNotes" class="input" name="" id="" [appMaxLength]="350" placeholder="Enter notes..."></textarea>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </form>
</ion-content>
